<script setup lang="ts">
import { computed } from 'vue';
import Avatar from 'primevue/avatar';
import TextTruncate from '@apparatix/library/TextTruncate.vue';
import type { DetailTabName, ForwardNavigable } from './types';
import { SectionIconography } from './SectionIconography';

interface AssociationListItemProps {
  associationType: 'contact' | 'account';
  id?: number;
  title: string;
  subtitle?: string;
  border?: boolean;
  tabId?: DetailTabName;
}

const emit = defineEmits<ForwardNavigable>();

const props = defineProps<AssociationListItemProps>();

const relationship = computed<'Account' | 'Contact'>(() => props.associationType === 'account' ? 'Account' : 'Contact');
</script>
<template>
  <div class="flex flex-col gap-2" :class="[props.border ? 'border-b border-[var(--neutral-background)] pb-2' : '']">
    <div class="flex items-center gap-4">
      <div class="flex-none w-12">
        <Avatar size="large" shape="circle" :style="{backgroundColor: SectionIconography[relationship].backgroundColor}">
          <template #icon>
            <component :is="SectionIconography[relationship].icon" size="1.5rem" :color="SectionIconography[relationship].color" />
          </template>
        </Avatar>
      </div>
      <div class="flex-initial w-72 flex flex-col gap-1 cursor-pointer" @click="emit('navigate-forward', { view: props.associationType, id: props.id, tabId: props.tabId});">
        <TextTruncate :text="props.title" :text-classes="['text-sm', 'font-medium', 'leading-snug', 'text-[var(--swimlane-primary-text)]']" />
        <TextTruncate v-if="props.subtitle" :text="props.subtitle" :text-classes="['text-xs', 'font-normal', 'leading-snug', 'text-[var(--swimlane-secondary-text)]']" />
      </div>
      <div class="flex-auto">
        <slot />
      </div>
    </div>
    <slot name="footer" />
  </div>
</template>
